import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

export const RenameDialog = ({ project, onCancel, onSave }) => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (project) setName(project.name || ""); }, [project]);
  const clean = name.trim();
  const submit = async (e) => {
    e.preventDefault();
    if (!clean || clean === project.name) return onCancel();
    setBusy(true);
    await onSave(project, clean);
    setBusy(false);
  };
  return (
    <Dialog open={!!project} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="sm:max-w-[420px] bg-white border-slate-200 rounded-3xl" data-testid="rename-dialog">
        <DialogTitle className="text-xl font-semibold text-slate-900">Rename app</DialogTitle>
        <DialogDescription className="text-sm text-slate-500">Only the name changes — your live and shared links stay the same.</DialogDescription>
        <form onSubmit={submit} className="space-y-4">
          <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} autoFocus data-testid="rename-input"
            className="w-full h-11 px-3.5 rounded-xl bg-slate-50 border border-slate-200 text-sm text-slate-800 outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-200 transition-colors" />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onCancel} data-testid="rename-cancel-btn" className="h-10 px-5 rounded-full border border-slate-200 text-sm text-slate-700 hover:bg-slate-50">Cancel</button>
            <button type="submit" disabled={busy || !clean} data-testid="rename-save-btn" className="h-10 px-5 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 disabled:opacity-50 flex items-center gap-2">
              {busy && <Loader2 size={14} className="animate-spin" />} Save
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RenameDialog;
